export enum SummaryComponentTypeEnum {
  PROCESS_INPUTS_OUTPUTS = "ProcessInputsOutputs",
  QUANTITY_SUMMARY = "QuantitySummary",
}

export type SummaryComponentType = SummaryComponentTypeEnum;
